import React from "react";

const StatusLabel = ({ status, color, isLoading = false }) => {
  return (
    <div
      className="ui white horizontal label"
      style={{
        backgroundColor: isLoading ? "grey" : color,
      }}
    >
      <div
        style={{
          wordWrap: "break-word",
          width: "90%",
          whiteSpace: "normal",
        }}
      >
        {isLoading ? "loading..." : status}
      </div>
    </div>
  );
};

export default StatusLabel;
